"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/* eslint no-use-before-define: "off" */

function parseBracketNotation(key, val, keyWrapper) {
  var obj = keyWrapper || {};
  var firstBracketIndex = key.indexOf('[');
  var secondBracketIndex = key.indexOf(']');
  var beforeBrackets = key.substring(0, firstBracketIndex);
  var afterBrackets = key.substring(secondBracketIndex + 2);
  if (firstBracketIndex !== -1) {
    var insideBrackets = key.substring(firstBracketIndex + 1, secondBracketIndex);
    var objectType = isNaN(insideBrackets) ? {} : [];
    obj[beforeBrackets] = obj[beforeBrackets] || objectType;
    if (afterBrackets) {
      obj[beforeBrackets][insideBrackets] = obj[beforeBrackets][insideBrackets] || {};
      obj[beforeBrackets][insideBrackets][afterBrackets] = val;
    } else {
      obj[beforeBrackets][insideBrackets] = val;
    }
    delete obj[key];
    var next = obj[beforeBrackets][insideBrackets];
    if (_typeof(next) === 'object') {
      transform(next);
    }
  }
}
function parseDotNotation(str, val, keyWrapper) {
  var obj = keyWrapper || {};
  var firstDotIdx = str.indexOf('.');
  var key = str.substring(0, firstDotIdx);
  var secondKey = str.substring(firstDotIdx + 1);
  obj[key] = obj[key] || {};
  obj[key][secondKey] = val;
  delete obj[str];
  if (_typeof(obj[key]) === 'object') {
    transform(obj[key]);
  }
}
function transform(obj) {
  Object.keys(obj).forEach(function (key) {
    var idxBracket = key.indexOf('[');
    var idxDot = key.indexOf('.');
    var hasDot = idxDot !== -1;
    var hasBracket = idxBracket !== -1;
    if (hasBracket && (!hasDot || idxBracket < idxDot)) {
      parseBracketNotation(key, obj[key], obj);
    } else if (hasDot) {
      parseDotNotation(key, obj[key], obj);
    }
  });
  return obj;
}
var _default = exports["default"] = transform;